import React from "react"

import { data } from './data';

import './style.scss'

export default function AcceptedPapers() {
  return (
    <div className='page-accepted-papers'>
      <div className="page-accepted-papers-title">Accepted Papers</div>
      {
        data.map(item => {
          return (
            <div className="page-accepted-papers-child-box" key={item.title}>
              <div className="page-accepted-papers-child-title">{item.title}</div>
              {
                item.content.map(itm => (
                  <div className="page-accepted-papers-content" key={itm.link}>
                    <div className="content-title">{itm.title}</div>
                    <div className="content-author">{itm.author}</div>
                    <a href={itm.link} target="_blank">PDF</a>
                  </div>
                ))
              }
            </div>
          )
        })
      }
    </div>
  )
}
